export class Register {
  public firstname: string;
  public lastname: string;
  public email: string;
  public password: string;
  public confirmPassword: string;
  public code: string;
}
